<script lang="ts">
	import * as m from '$paraglide/messages';
	import DatasheetDetailBlock from './DatasheetDetailBlock.svelte';

	interface Props {
		streetName?: string;
		city?: string;
	}

	const { streetName, city }: Props = $props();
</script>

<DatasheetDetailBlock title={m.poi_datasheet__location()}>
	<address class="font-not-italic">
		{#if streetName}{streetName}<br />{/if}
		{city}
	</address>
</DatasheetDetailBlock>
